import axiosInstance from "./axiosInstance";

// جيب تنبيهات المخزون (all | low | out)
export const getInventoryAlerts = (type = "all") =>
  axiosInstance.get("/dashboard/inventory-alerts/", { params: { type } });

// عدّل الـ stock لمنتج معين (بديل مبسّط — كل منتج له ghost variant واحد بس)
export const updateProductStock = (productId, stock) =>
  axiosInstance.patch(`/products/${productId}/stock/`, { stock });
